export const QUALITY_CRITERIA_LIST = [
  `Лидеры рынка со стажем более 5 лет`,
  `Есть опыт работы со сложными кейсами`,
  `Знают стратегии торга`,
  `Хорошая репутация на Циане`,
  `Получают отличные отзывы от клиентов`,
  `Закрыли много сделок`,
  `Своевременно отвечают на звонки и сообщения`,
  `Подтвердили свои документы`,
];
